import * as R from 'ramda';

import {
  NOTIFICATIONS_ADD,
  NOTIFICATIONS_REMOVE,
  NOTIFICATIONS_REPLACE,
} from './actions';

const initial = [];

const addNotification =
  (state, { notification }) => R.append(notification, state);

const removeNotification =
  (state, { notification }) => R.reject(R.equals(notification), state);

const replaceNotification =
  (state, { notification, newNotification }) => {
    const idx = R.findIndex(R.equals(notification.key), R.map(R.prop('key'), state));
    const notification$ = {
      ...newNotification,
      key: notification.key,
    };

    return idx === -1
      ? R.append(notification$, state)
      : R.update(idx, notification$, state)
    ;
  };

export default (state = initial, action) => {
  const reducer = {
    [NOTIFICATIONS_ADD]: addNotification,
    [NOTIFICATIONS_REMOVE]: removeNotification,
    [NOTIFICATIONS_REPLACE]: replaceNotification,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
